import React, { Component } from 'react';
import { connect } from "react-redux";
import ChannelUtilizationChart from '../../components/bar-charts/ChannelUtilizationChart';
import CustomSelect from "../../components/common/select/Select";
import PratDashboardMiddleware from '../../store/prat_middleware/pratDashboard/pratDashboardMiddleware';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import DATA from '../../assets/data';
import { compare } from '../gt/validation/sort';
import CustomToast from '../../util-functions/customToast.jsx'

class ChannelUtilization extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCategory: [],
            selectedYearTo: '',
            selectedYearFrom: '',
            selectedMonthTo: [],
            selectedMonthFrom: [],
            data: [],
            popUp: false,
            months: DATA.QUARTER_MONTHS,
            years: DATA.YEARSPreVsPostOpso,
            filePopUp: false,
            divisions: [],
            selectedDivisions: []
        };
    }

    componentDidMount() {
        let currentDate = new Date();
        let currentMonth = currentDate.getMonth();
        let currentYear = currentDate.getFullYear();
        let currentYearIndex = this.state.years.findIndex(year => year.value === currentYear);

        this.handleMonthFromCheck(currentMonth, false)       // Marking current month check on component mounting
        this.handleYearFromCheck(currentYearIndex - 1, false)       // Marking year 2019 check on component mounting
        this.handleMonthToCheck(currentMonth, false)       // Marking current month check on component mounting
        this.handleYearToCheck(currentYearIndex, false)       // Marking year 2020 check on component mounting


        let arr = []
        if (this.props.categories) {
            this.props.categories.forEach(item => {
                arr.push(item.guid)
            })
            this.setState({
                selectedCategory: arr
            }, () => {
                setTimeout(() => {
                    console.log('hello 1st')
                    this.props.getChannelUtilization(
                        this.state.selectedCategory,
                        (currentYear - 1),
                        currentYear,
                        [],
                        [currentMonth],
                        this.state.selectedDivisions
                    );
                }, 700)
            })
        }
        else{
            setTimeout(() => {
                console.log('hello')
                this.handleSubmit()
            }, 3000);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.categories !== this.props.categories) {
            let arr = []
            this.props.categories.forEach(item => {
                arr.push(item.guid)
            })
            this.setState({
                selectedCategory: arr
            }, () => {
                console.log('hello')
                this.handleSubmit();
            })
        }

        if (prevProps.product_divisions !== this.props.product_divisions) {
            // console.log(this.props.product_divisions)
            let arr = this.props.product_divisions.map(item => (
                {
                    Name: item.Name,
                    guid: item.guid,
                    isTrue: false
                }
            ))
            this.setState({
                divisions: arr
            })
        }
    }

    handleCategory = (category) => {
        let arr = [];
        if (category === null || category.length === 0) {
            this.setState({
                selectedCategory: []
            }, () => {
                this.handleSubmit()
            });
        } else {
            category.forEach((element) => {
                arr.push(element.value);
            });
            this.setState({ selectedCategory: arr }, () => {
                this.handleSubmit()
            });
        }
    };

    handleSubmit = () => {
        console.log('hi')
        this.props.getChannelUtilization(
            this.state.selectedCategory,
            this.state.selectedYearFrom,
            this.state.selectedYearTo,
            this.state.selectedMonthFrom,
            this.state.selectedMonthTo,
            this.state.selectedDivisions
        );
    }

    handleMonthFromCheck = (ind, isSubmit) => {
        let newArray = [...this.state.months]
        newArray[ind] = { ...newArray[ind], MCTcheckedFrom: !newArray[ind].MCTcheckedFrom }
        this.setState({
            months: newArray
        },
            () => {
                let filterCheckedValues = []
                this.state.months.forEach(item => {
                    if (item.MCTcheckedFrom) {
                        filterCheckedValues.push(item.value)
                    }
                })
                this.setState({
                    selectedMonthFrom: filterCheckedValues
                }, () => {
                    isSubmit ? this.handleSubmit() : void 0;
                })
            })
    }

    handleMonthToCheck = (ind, isSubmit) => {
        let newArray = [...this.state.months]
        newArray[ind] = { ...newArray[ind], MCTcheckedTo: !newArray[ind].MCTcheckedTo }
        // this.state.months[ind].MCTcheckedTo = !this.state.months[ind].MCTcheckedTo
        this.setState({
            months: newArray
        },
            () => {
                let filterCheckedValues = []
                this.state.months.forEach(item => {
                    if (item.MCTcheckedTo) {
                        filterCheckedValues.push(item.value)
                    }
                })
                this.setState({
                    selectedMonthTo: filterCheckedValues
                }, () => {
                    isSubmit ? this.handleSubmit() : void 0;
                })
            })
    }

    handleYearFromCheck = (ind, isSubmit) => {
        this.state.years.forEach((item, index) => {
            if (ind === index) {
                this.state.years[index].MCTcheckedFrom = true       // eslint-disable-line
                this.setState({
                    years: this.state.years,
                    selectedYearFrom: item.value
                }, () => {
                    isSubmit ? this.handleSubmit() : void 0;
                })
            } else {
                this.state.years[index].MCTcheckedFrom = false      // eslint-disable-line
            }
        })
    }

    handleYearToCheck = (ind, isSubmit) => {

        this.state.years.forEach((item, index) => {
            if (ind === index) {
                this.state.years[index].MCTcheckedTo = true         // eslint-disable-line
                this.setState({
                    years: this.state.years,
                    selectedYearTo: item.value
                }, () => {
                    isSubmit ? this.handleSubmit() : void 0;
                })
            } else {
                this.state.years[index].MCTcheckedTo = false        // eslint-disable-line
            }
        })
    }

    handleChannelUtiXlsxDownload = () => {
        if (this.state.selectedCategory.length) {
            this.props.downloadChannelUtiXlsx(this.state.selectedCategory, this.state.selectedDivisions)
        } else {
            CustomToast('error', 'Category not selected!')
        }
    }

    handleDivisionsCheck = (ind) => {
        let newArray = [...this.state.divisions]
        newArray[ind] = { ...newArray[ind], isTrue: !newArray[ind].isTrue }
        this.setState({
            divisions: newArray
        },
            () => {
                let filterCheckedValues = newArray.filter(item => item.isTrue).map(item => (
                    item.guid
                ))
                this.setState({
                    selectedDivisions: filterCheckedValues
                }, () => {
                    this.handleSubmit()
                })
            })
    }

    render() {
        return (
            <div className='dtts-container' style={{ minHeight: '600px' }}>

                <div className='dtts-heading-cta'>

                    <span className='dtts-heading'>Major Channel Utilization</span>

                    <CustomSelect.MyCustomSelect
                        className='filter-font-size channel-utilization-select'
                        placeholder={"Category"}
                        allowSelectAll={true}
                        isMulti
                        options={
                            this.props.categories
                                ? !this.props.categories
                                    ? void 0
                                    : this.props.categories.sort(compare).map(item => ({
                                        value: item.guid,
                                        label: item.Name
                                    }))
                                : []
                        }
                        onChange={this.handleCategory}
                        value={
                            this.props.categories
                                ? this.props.categories
                                    .filter(item => {
                                        return !this.state.selectedCategory
                                            ? void 0
                                            : this.state.selectedCategory.includes(item.guid);
                                    })
                                    .map(item => {
                                        return {
                                            value: item.guid,
                                            label: item.Name
                                        };
                                    }) : void 0
                        }
                    />
                    <div className='dtts-cta-container'>
                        <div className='funnel-filter-container'>
                            <img alt='' className='funnel-filter-image' src={require('../../assets/images/funnelFilter.svg')} onClick={() => { this.setState({ popUp: !this.state.popUp }) }} />
                            {/* Funnel Icon Popup Filter */}
                            {this.state.popUp ?
                                <ClickAwayListener onClickAway={() => { this.setState({ popUp: false }) }}>
                                    <div className='funnel-pop-up' style={{ width: 'fit-content', overflowY: 'auto' }}>

                                        <div className='popUp-columns'>
                                            <span className='popUp-heading'>Divisions</span>
                                            <div className='promo-column'>
                                                {
                                                    this.state.divisions && this.state.divisions.map((item, indx) => (
                                                        <span className='column-item' key={indx}>
                                                            <input type='checkbox' className='column-item-input' checked={item.isTrue}
                                                                onChange={() => this.handleDivisionsCheck(indx)} />
                                                            <label style={{ whiteSpace: 'nowrap' }}>{item.Name}</label>
                                                        </span>
                                                    ))
                                                }
                                            </div>
                                        </div>

                                        <span style={{ height: '100%', width: '2px', backgroundColor: 'lightgrey', marginRight: '10px' }}></span>

                                        <div className='popUp-columns'>
                                            <span className='popUp-heading'>Month From</span>
                                            <div className='month-column'>
                                                <div className='promo-column'>
                                                    {
                                                        this.state.months.filter((item, ind) => {
                                                            return ind <= 5 ? item : null
                                                        })
                                                            .map((item, indx) => (
                                                                <span className='column-item' key={indx}>
                                                                    <input type='checkbox' className='column-item-input' checked={item.MCTcheckedFrom}
                                                                        onChange={() => this.handleMonthFromCheck(indx, true)} />
                                                                    <label>{item.name}</label>
                                                                </span>
                                                            ))
                                                    }
                                                </div>
                                                <div className='promo-column'>
                                                    {
                                                        this.state.months.filter((item, ind) => {
                                                            return ind > 5 ? item : null
                                                        })
                                                            .map((item, indx) => (
                                                                <span className='column-item' key={indx}>
                                                                    <input type='checkbox' className='column-item-input' checked={item.MCTcheckedFrom}
                                                                        onChange={() => this.handleMonthFromCheck((indx + 6), true)} />
                                                                    <label>{item.name}</label>
                                                                </span>
                                                            ))
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <div className='popUp-columns'>
                                            <span className='popUp-heading'>Year From</span>
                                            <div className='promo-column'>
                                                {
                                                    this.state.years.map((item, indx) => (
                                                        <span className='column-item' key={indx}>
                                                            <input type='radio' className='column-item-input' checked={item.MCTcheckedFrom}
                                                                onChange={() => this.handleYearFromCheck(indx, false)} />
                                                            <label>{item.label}</label>
                                                        </span>
                                                    ))
                                                }
                                            </div>
                                        </div>

                                        <span style={{ height: '100%', width: '2px', backgroundColor: 'lightgrey' }}></span>

                                        <div className='popUp-columns' style={{ marginLeft: '10px' }}>
                                            <span className='popUp-heading'>Month To</span>
                                            <div className='month-column'>
                                                <div className='promo-column'>
                                                    {
                                                        this.state.months.filter((item, ind) => {
                                                            return ind <= 5 ? item : null
                                                        })
                                                            .map((item, indx) => (
                                                                <span className='column-item' key={indx}>
                                                                    <input type='checkbox' className='column-item-input' checked={item.MCTcheckedTo}
                                                                        onChange={() => this.handleMonthToCheck(indx, true)} />
                                                                    <label>{item.name}</label>
                                                                </span>
                                                            ))
                                                    }
                                                </div>
                                                <div className='promo-column'>
                                                    {
                                                        this.state.months.filter((item, ind) => {
                                                            return ind > 5 ? item : null
                                                        })
                                                            .map((item, indx) => (
                                                                <span className='column-item' key={indx}>
                                                                    <input type='checkbox' className='column-item-input' checked={item.MCTcheckedTo}
                                                                        onChange={() => this.handleMonthToCheck((indx + 6), true)} />
                                                                    <label>{item.name}</label>
                                                                </span>
                                                            ))
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <div className='popUp-columns'>
                                            <span className='popUp-heading'>Year To</span>
                                            <div className='promo-column'>
                                                {
                                                    this.state.years.map((item, indx) => (
                                                        <span className='column-item' key={indx}>
                                                            <input type='radio' className='column-item-input' checked={item.MCTcheckedTo}
                                                                onChange={() => this.handleYearToCheck(indx, true)} />
                                                            <label>{item.label}</label>
                                                        </span>
                                                    ))
                                                }
                                            </div>
                                        </div>

                                    </div>
                                </ClickAwayListener>
                                :
                                null
                            }
                        </div>
                        <img alt='' className='images-style' src={require('../../assets/images/refreshArrows.svg')} onClick={this.handleSubmit} />
                        <div className="funnel-filter-container">
                            <div style={{ display: 'flex', cursor: 'pointer' }}
                                onClick={() => {
                                    this.setState({ filePopUp: !this.state.filePopUp });
                                }}
                            >
                                <img
                                    className="image-transform"
                                    src={require("../gt/images/dots.png")}
                                    alt=''
                                />
                            </div>

                            {this.state.filePopUp ? (
                                <ClickAwayListener
                                    onClickAway={() => {
                                        this.setState({ filePopUp: false });
                                    }}
                                >
                                    <div
                                        className="funnel-pop-up"
                                        style={{ width: "140px", height: 'auto', flexDirection: 'column' }}
                                    >
                                        {/* <span className="division-cta">
                      <input type='checkbox' value={this.state.isDivision} onChange={() => this.setState({ isDivision: !this.state.isDivision })} />
                      <label>Division</label>
                    </span> */}
                                        <button className='xlsx-download-cta' onClick={this.handleChannelUtiXlsxDownload}>Download Excel</button>
                                    </div>
                                </ClickAwayListener>
                            ) : null}
                        </div>
                    </div>

                </div>

                {this.props.isGTMTSplitLoading ?
                    <div style={{ marginTop: '100px' }}>
                        {/* Loading */}
                        <img alt='' src={require('../../assets/images/barsLoader.svg')} style={{ width: '60px', height: '60px' }} />
                    </div>
                    :
                    // Graph
                    <ChannelUtilizationChart data={this.props?.channelUtilization} />
                }

            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        channelUtilization: state.PratDashboardReducer.channelUtilization,
        isChannelUtilizationLoading: state.PratDashboardReducer.isChannelUtilizationLoading
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getChannelUtilization: (
            selectedCategory,
            selectedYearFrom,
            selectedYearTo,
            selectedMonthFrom,
            selectedMonthTo,
            selectedDivisions
        ) => {
            return dispatch(PratDashboardMiddleware.getChannelUtilization(
                selectedCategory,
                selectedYearFrom,
                selectedYearTo,
                selectedMonthFrom,
                selectedMonthTo,
                selectedDivisions
            ));
        },
        downloadChannelUtiXlsx: (selectedCategory, selectedDivisions) => {
            return dispatch(
                PratDashboardMiddleware.downloadChannelUtiXlsx(
                    selectedCategory,
                    selectedDivisions
                )
            );
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ChannelUtilization);
